import React from 'react';
import PropTypes from 'prop-types';

import WidgetMenuToggle from '../widgetMenuToggle/WidgetMenuToggle';

import useStyles from './widgetHeader.styles';

export function WidgetHeaderComponent({ id, lock, name, ...props }) {
  const { widgetHeader } = useStyles();
  const widgetId = id.split('_').shift().toLowerCase();

  return (
    <div className={widgetHeader} data-qa={`widget-header-container-${widgetId}`}>
      {/* inlining the style to override GluOverrides styles */}
      <h2 data-qa={`widget-header-${widgetId}`}>{name}</h2>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {!lock && <WidgetMenuToggle {...props} widgetId={widgetId} widgetName={name} />}
    </div>
  );
}

WidgetHeaderComponent.propTypes = {
  lock: PropTypes.bool,
  name: PropTypes.string.isRequired,
  id: PropTypes.string
};

WidgetHeaderComponent.defaultProps = {
  lock: false,
  id: null
};

export default WidgetHeaderComponent;
